import { createContext } from 'react';
import { IServiceLookupDto } from '@shared/api';

export interface ILookupsContext {
    lookups: IServiceLookupDto[] | null;
    lookupsLoading: boolean;
}

export const LookupsContext = createContext<ILookupsContext>({
    lookups: null,
    lookupsLoading: false,
});
